import { ArrowPathIcon } from '@heroicons/react/24/outline';

interface DeliverFooterProps {
    canDeliver: boolean;
    isSubmitting: boolean;
    onDeliver: () => void;
}

export function DeliverFooter({ canDeliver, isSubmitting, onDeliver }: DeliverFooterProps) {
    return (
        <div className="flex-shrink-0 mt-3 pt-3 pb-1 border-t border-gray-200">
            <button
                type="button"
                onClick={canDeliver ? onDeliver : undefined}
                disabled={!canDeliver || isSubmitting}
                className={`w-full h-11 rounded-full text-sm font-bold transition-colors flex items-center justify-center gap-2 ${
                    canDeliver && !isSubmitting
                        ? 'bg-gray-900 text-white hover:bg-gray-800 cursor-pointer'
                        : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                }`}
            >
                {isSubmitting && <ArrowPathIcon className="w-4 h-4 animate-spin" />}
                {canDeliver ? 'Mark aligners as delivered →' : 'Acknowledge to continue'}
            </button>
        </div>
    );
}
